import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResumeDto } from 'src/app/models/configurators-2d/applications/decking-boards/resume-dto';
import { Ean } from 'src/app/models/configurators-2d/resume/ean';
import { DeckingBoardsService } from 'src/app/services/configurators-2d/applications/decking-boards.service';
import { DeckingBoardsConfiguratorItem } from '../../configurator/applications/decking-boards-configurator-item';
import { IBaseComponent } from '../../configurator/i-base-component';
import { DeckingBoardsPreviewComponent } from '../preview/preview.component';
import { Configurators2DComponent } from '../../configurators-2d.component';

@Component({
  selector: 'ng-decking-boards-summary',
  templateUrl: './summary.component.html',
})
export class DeckingBoardsSummaryComponent extends DeckingBoardsConfiguratorItem implements OnInit, IBaseComponent {
  currentLang: string;
  isLoading: boolean;

  preview: DeckingBoardsPreviewComponent;

  constructor(
    deckingBoardsService: DeckingBoardsService,
    private translate: TranslateService,
    configurators2DComponent: Configurators2DComponent
  ) {
    super(deckingBoardsService);
    this.preview = configurators2DComponent.preview as DeckingBoardsPreviewComponent;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.currentLang = this.translate.getBrowserLang();
    this.configuration.isComplete = true;
    this.service.getResume<ResumeDto>().then(res => {
      if (res) {
        this.isLoading = false;
      }
    });

    this.preview.update();
  }

  getCategories(): string[] {
    let propertyName = this.getPropertyNameLocalize('categoryName');

    let categories = [...new Map(this.configuration.resume.products.map(cp => [cp[propertyName], cp])).values()];

    return categories.map(cp => cp[propertyName]);
  }

  getProducts(categoryName: string): Ean[] {
    return this.configuration.resume.products.filter(
      e => e[this.getPropertyNameLocalize('categoryName')] === categoryName
    );
  }

  getPropertyNameLocalize(propertyName: string) {
    return propertyName + this.currentLang[0].toUpperCase() + this.currentLang.substring(1).toLowerCase();
  }

  isNextButtonActive(): boolean {
    return this.configuration.resume !== undefined;
  }

  checkPageChangeCapability(): boolean {
    return true;
  }
}
